import { render, staticRenderFns } from "./ClassManagementForm.vue?vue&type=template&id=778257ab"
import script from "./ClassManagementForm.vue?vue&type=script&lang=js"
export * from "./ClassManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports